import * as React from "react";
import {
  GranteeListItemTitle,
  GranteeInfo,
  StyledGranteeIcon,
  GranteeListItemContainer
} from "components/permissions/CommonStyledComponents";
import TitleCell from "collections/components/EntitiesList/cells/TitleCell";
import { useTranslation } from "react-i18next";
const CollectionGranteesListItem = ({
  grantee: { grantee, granteeName, capability, collection_name, collection_total, collection_id }
}) => {
  const { t } = useTranslation("enterprise_collections");
  const capabilityRole = {
    view: t("grantee_list_item.role_viewer"),
    manage: t("grantee_list_item.role_manager"),
    own: t("grantee_list_item.role_owner")
  };
  return /* @__PURE__ */ React.createElement(GranteeListItemContainer, { $currentState: null }, /* @__PURE__ */ React.createElement(GranteeInfo, { title: granteeName }, /* @__PURE__ */ React.createElement(StyledGranteeIcon, { type: (grantee == null ? void 0 : grantee.includes("user")) ? "user" : "team" }), /* @__PURE__ */ React.createElement(GranteeListItemTitle, null, granteeName)), /* @__PURE__ */ React.createElement(GranteeInfo, null, /* @__PURE__ */ React.createElement(TitleCell, { name: collection_name, type: "collection", id: collection_id }), collection_total > 1 && /* @__PURE__ */ React.createElement("span", null, "\xA0", t("grantee_list_item.more", { number: collection_total - 1 }))), /* @__PURE__ */ React.createElement(GranteeInfo, null, capabilityRole[capability]));
};
export default CollectionGranteesListItem;
